import api from "./api";

// Tela /permissoes (Fase 4): catalogo de telas + grade de permissoes por perfil.
const permissionsService = {
  getScreens: () => api.get("/permissions/screens").then((r) => r.data),
  getPermissions: () => api.get("/permissions").then((r) => r.data),
  upsertPermission: (payload) => api.put("/permissions", payload).then((r) => r.data),
  savePermissionsBulk: (rows) => api.put("/permissions/bulk", rows).then((r) => r.data),

  // Catálogo de perfis (criar/excluir perfis customizados por empresa).
  getProfiles: () => api.get("/permissions/profiles").then((r) => r.data),
  createProfile: (name, description) =>
    api.post("/permissions/profiles", { name, description }).then((r) => r.data),
  deleteProfile: (id) => api.delete(`/permissions/profiles/${id}`).then((r) => r.data),
};

export default permissionsService;
